import React, { useEffect, useState } from "react";
import icon from "../assets/apple-touch-icon.png";
import { NavLink, useLocation } from "react-router-dom";
import LoginForm from "../components/login/LoginForm";
import Otp from "../components/login/mfa/Otp";

const Login = () => {
  const location = useLocation();
  const [showMfa, setShowMfa] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get("type");

    setShowMfa(type === "otp");
  }, [location.search]);

  return (
    <section className="max-w-[1650px] mx-auto py-6 px-10 bg-custom-bg bg-cover bg-center min-h-screen">
      <header>
        <div className="flex justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-1">
            <img src={icon} alt="icon" className="h-10 w-10 text-orange-500" />
            <h3 className="text-xl font-bold">Vaspay</h3>
          </div>
          <NavLink
            to="/register"
            className="px-4 py-2 rounded-md bg-red-500 text-white font-medium hover:bg-red-600 transition-colors duration-200 capitalize"
          >
            register
          </NavLink>
        </div>
      </header>
      <main>
        {!showMfa ? (
          <LoginForm path={location.pathname} />
        ) : (
          <Otp path={location.pathname} />
        )}
      </main>
    </section>
  );
};

export default Login;
